export { default, getServerSideProps } from './[...path]';
